var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alumno-cursado-a-b-m',{attrs:{"headers":_vm.headers,"cursada_id":_vm.cursada_id,"only":_vm.only},scopedSlots:_vm._u([{key:"item.carreras",fn:function(ref){
var item = ref.item;
return _vm._l((item.alumno.carreras),function(carrera){return _c('span',{key:carrera.id},[_vm._v(_vm._s(carrera.codigo))])})}},{key:"item.email_enviado",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":item.mail_enviado > 0 ? 'success' : ''}},[_vm._v(_vm._s(item.mail_enviado))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }